import React, { useEffect } from "react";
import ReportTab from "./ReportTab";
import ReportDetails from "./ReportDetails";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";

const OpennessToExperience = (props: any) => {
    const scoreDescription = {
        High: ["Inquisitive", "Creative", "Curious", "Unconventional", "Imaginative"],
        Moderate: ["Practical", "Good problem-solver", "Open to change", "Appreciates Stability", "Level-Headed"],
        Low: ["Very Practical", "Prefers Familiarity", "Down to Earth", "Traditional", "Resistant to Change"],
    };
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row between-xs middle-xs">
                <div className="col-xs">
                    <h1 className="title-page" id={"title-page-" + props.name} tabIndex={-1}>
                        RepIQ™ Reputation Analyzer Report
                    </h1>
                </div>
            </div>

            <ReportTab selectedTab="4" />

            <div className="row" id="content">
                <div className="col-xs-12">
                    <div className="box">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">Openness to Experience</h2>
                                </div>
                            </div>
                        </div>
                        <div className="box-content">
                            <div className="row">
                                <div className="col-xs-12 col-sm-9">
                                    <p>
                                        Openness to Experience measures someone's comfort with the unfamiliar. People who score high in Openness to Experience are
                                        often seen as creative, adventurous, and insightful. They are adept out-of-the-box thinkers, who are eager to learn new
                                        things and welcome novel experiences.
                                    </p>
                                    <p>
                                        People who score low in Openness to Experience prefer the familiar and are more resistant to change. They tend to embrace
                                        tradition, practicality, and concrete thinking over abstract ideas.
                                    </p>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <div role="option" className="img-container">
                                        <img src="images/img-openness-to-experience.jpg" alt="Man Parachuting" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ReportDetails title={"Openness to Experience"} name={"OpennessToExperiences"} scoreDescription={scoreDescription} />
                </div>
            </div>
        </React.Fragment>
    );
};
export default OpennessToExperience;
